export class HaPatientimport {
  sNo: string;
  id: string;
  patientId: string;
  firstName: string;
  middleName: string;
  lastName: string;
  sex: string;
  sexView: string;
  Dob;
  dobShow: string;
  ssn: string;
  mobileNo: string;
  emailId: string;
  address: string;
  zip: string;
  insurance: string;
  state: string;
  country: string;
  bloodGroup: string;
  vitamins: string;
  knownAllergy: string;
  surgicalHistory: string;
  otherMedicine: string;
  errorName: string;
  errorDetail: string;
  isEnabled: boolean;
  city: string;

}
